import { logout } from "@/entities/authSlice";
import {
  Middleware,
  MiddlewareAPI,
  isRejectedWithValue,
} from "@reduxjs/toolkit";

interface ErrorResponse {
  status: number;
  data: unknown;
}

export const errorHandler: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const payload = action.payload as ErrorResponse;
      if (payload.status === 401) {
        api.dispatch(logout());
      }
    }

    return next(action);
  };
